import { render, staticRenderFns } from "./landing-footer.vue?vue&type=template&id=f92a0b32&scoped=true&"
import script from "./landing-footer.vue?vue&type=script&lang=js&"
export * from "./landing-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92a0b32",
  null
  
)

export default component.exports